// extracted by mini-css-extract-plugin
module.exports = {"hero":"Navbar_hero__AgBt-","active":"Navbar_active__3mbhk"};